import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sd-arrow-carvet-up",
  "use": "sd-arrow-carvet-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sd-arrow-carvet-up\"><path d=\"M8.501 14a.5.5 0 01-.354-.854l3-3a.5.5 0 01.708 0l3 3A.5.5 0 0114.5 14h-6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol